/* istanbul ignore file */
const setVh = () => {
    // Trick to make app stitch to fit full screen in mobile
    // ref: https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    // Then we set the value in the --vh custom property to the root of the document
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
};

const attrKey = 'set-vh';

export const registerSetViewHeight = () => {
    const alreadySet = document.documentElement.getAttribute(attrKey) === 'true';

    if (alreadySet) return;

    // check attr at the document to prevent re-adding resize event listener
    document.documentElement.setAttribute(attrKey, 'true');

    window.addEventListener('resize', setVh);
    setVh();
};
